// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"295":"519e0b31","998":"e0c2dae2"}[chunkId] + ".css";
};